module.exports = __webpack_public_path__ + "static/media/dong-xie-1vwOXJXxbrE-unsplash.2f485ef4.jpg";